/**
 * Zehnplus quantity options (blocks/zp-menge.liquid).
 * Copies the chosen option into the standard quantity input of the product form.
 */

/**
 * @param {Element} origin - An element inside the product section.
 * @returns {{ input: HTMLInputElement, checked: HTMLInputElement } | null}
 */
function findPair(origin) {
  const section = origin.closest('.shopify-section');
  if (!section) return null;

  const input = section.querySelector('.buy-buttons-block input[name="quantity"]');
  const checked = section.querySelector('[data-zp-menge] input:checked');

  if (!(input instanceof HTMLInputElement) || !(checked instanceof HTMLInputElement)) return null;

  return { input, checked };
}

/** @param {Element} origin */
function syncQuantity(origin) {
  const pair = findPair(origin);
  if (!pair || pair.input.value === pair.checked.value) return;

  pair.input.value = pair.checked.value;
  pair.input.dispatchEvent(new Event('input', { bubbles: true }));
  pair.input.dispatchEvent(new Event('change', { bubbles: true }));
}

document.addEventListener('change', (event) => {
  const target = event.target;
  if (target instanceof HTMLInputElement && target.closest('[data-zp-menge]')) {
    syncQuantity(target);
  }
});

// The theme may reset the quantity input after adding to cart; make sure the chosen option wins.
document.addEventListener(
  'submit',
  (event) => {
    if (event.target instanceof HTMLFormElement) syncQuantity(event.target);
  },
  true
);
